import LangSelector from './components/lang-selector';
import SiteHeader from './components/site-header';
import NewsSlider from './components/news-slider';
import PartnersSlider from './components/partners-slider';
//import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import HeaderSlider from "./components/header-slider";
import ImgGallery from "./components/img-gallery";
import GalleryImgSlider from "./components/gallery-img-slider";
import DeviceManager from './utils/device-manager';
import BurgerMenu from './components/burgermenu';
import MenuDesktop from './components/menu-desktop';
import BackToTop from './components/back-to-top';
import TypeView from './components/type-view';
import ActualiteLoadMore from "./components/actualite-load-more";
import HorseLoadMore from "./components/horse-load-more";
import ShareMailForm from "./components/share-mail-form";

(function($) {
    window.$ = $;
    const lang = typeof ver.lang !== 'undefined' ? ver.lang : 'en';

    $(function() {
        const $html = $('html');

        // Touch device detection
        if(DeviceManager.isHandheld()) {
            $html.addClass('touch');

            if(DeviceManager.isIos()) {
                $html.addClass('ios');
            }
        }
        else {
            $html.addClass('no-touch');
        }

        // IE detection
        if(DeviceManager.isIe11()) {
            $html.addClass('ie11');
        }
        else if(DeviceManager.isEdge()) {
            $html.addClass('edge');
        }

        // Handheld menu
        //const handheldMenu = new HandheldMenu();

        // General components
        const langSelector = new LangSelector($('.language-selector'));
        const siteHeader = new SiteHeader($('.site-header'), 20);
        //const dropdownMenu = new DropdownMenu($('.header__nav'));

        // News slider component
        /*const $newsSliders = $('.news-slider');
        if($newsSliders.length) {
            $newsSliders.each(function(index, el) {
                const newsSlider = new NewsSlider($(el));
            });
        }*/

        // Partners slider component
        const $partnersSliders = $('.partners-slider');
        if($partnersSliders.length) {
            $partnersSliders.each(function(index, el) {
                const partnerSlider = new PartnersSlider($(el));
            });
        }

        // Cookie consent
        if(typeof tarteaucitron !== 'undefined' && tarteaucitron) {
            // Tarteaucitron cookie settings
            let tarteaucitronLang = lang || 'en';

            if(lang === 'cn') {
                tarteaucitronLang = 'en';
            }

            const cookiesConsent = new CookiesConsent(tarteaucitronLang);
        }

        // Actualite load more component
            const $actualiteLoadMoreBtns = $('.actualite-load-more');
            if($actualiteLoadMoreBtns.length) {
                $actualiteLoadMoreBtns.each(function(index, el) {
                    const actualiteLoadMore = new ActualiteLoadMore($(el));
                });
            }

        // Horse load more component
            const $horseLoadMoreBtns = $('.horse-load-more');
            if($horseLoadMoreBtns.length) {
                $horseLoadMoreBtns.each(function(index, el) {
                    const horseLoadMore = new HorseLoadMore($(el));
                });
            }
    });

    if (window.matchMedia("(max-width: 991px)").matches) {
      $('.slider-mobile').flickity({
        autoPlay: true,
        pageDots: false,
        wrapAround: true,
        prevNextButtons: false
      });
    }

})(jQuery);
